export const capitalize = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const currencyFormatter = (value, currency) => {
  return value.toLocaleString(undefined, {
    style: "currency",
    currency: currency ? currency : "NGN",
  });
};

export const currency = (value) => {
  return Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const dateFormatter = (timeStamp) => {
  const value = new Date(timeStamp);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  // const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const month = months[value.getMonth()];
  const date = value.getDate();
  const year = value.getFullYear();
  return `${month} ${date}, ${year}`;
};

export const YYYYMMDDHHmmSS = (date) => {
  const pad2 = (n) => {
    // always returns a string
    return (n < 10 ? "0" : "") + n;
  };

  return (
    date.getFullYear() +
    pad2(date.getMonth() + 1) +
    pad2(date.getDate()) +
    pad2(date.getHours()) +
    pad2(date.getMinutes()) +
    pad2(date.getSeconds())
  );
};

export const str2bool = (value) => {
  if (value && typeof value === "string") {
    if (value.toLowerCase() === "true") return true;
    if (value.toLowerCase() === "false") return false;
  }
  return value;
};
